import _ from "lodash";

import Event from "@/services/Event";

import ParseHTTPError from "@/helpers/ParseHTTPError";
// Steps
import Team from "@/pages/Registration/Steps/Team";
import EventKind from "@/pages/Registration/Steps/EventKind";
import EventStep from "@/pages/Registration/Steps/Event";
import Confirm from "@/pages/Registration/Steps/Confirm";
import Judge from "@/pages/Registration/Steps/Judge";

import moment from "moment";

import { mapState } from "vuex";

export default {
  name: "Registration",

  data: function() {
    return {
      currentStep: 0,
      loading: false,
      loadingJudge: true,
      steps: [],

      teamSteps: [
        { title: "Selecione a equipe", component: Team },
        { title: "Etapa do torneio", component: EventKind },
        { title: "Escolha o torneio", component: EventStep },
        { title: "Confirmar inscrição", component: Confirm },
      ],

      judgeSteps: [
        { title: "Etapa do torneio", component: EventKind },
        { title: "Escolha o torneio", component: EventStep },
        { title: "Cadastro das informações", component: Judge },
        { title: "Confirmar inscrição", component: Confirm },
      ],

      selectedTeam: {},
      selectedEventKind: {},
      selectedEvent: {},
    };
  },

  components: {
    Team,
    EventKind,
    EventStep,
    Confirm,
  },

  computed: {
    ...mapState(["community", "isJudge", "user", "userInfo"]),

    isJudgePending() {
      return (
        this.isJudge &&
        (!_.get(this.user, "judge.experience") ||
          !_.get(this.user, "judge.language"))
      );
    },

    isJudgeMinor() {
      return this.user.birth && moment().diff(this.user.birth, "years") < 18;
    },
  },

  created() {
    if (this.isJudge) {
      this.steps = this.judgeSteps;
      const userId = _.get(this.userInfo, "_id", null);
      this.selectedTeam = { _id: userId };
      this.$store.dispatch("getUserInfo", () => {
        this.$store.dispatch("updateMe");

        const userId = _.get(this.userInfo, "_id", null);
        if (userId) this.selectedTeam = { _id: userId };
        setTimeout(() => {
          this.loadingJudge = false;
        }, 2000);
      });
    } else {
      this.steps = this.teamSteps;
    }
  },

  methods: {
    goBack() {
      if (this.currentStep == 0) return this.$router.push({ name: "home" });

      this.currentStep--;
      this.emptyStep(this.currentStep);
    },

    selectTeam(team) {
      this.selectedTeam = team;
      this.steps[this.currentStep]["description"] = this.selectedTeam.name;
      this.currentStep++;
    },

    emitJudgeInfo(judge) {
      this.steps[this.currentStep]["description"] = this.selectedEvent.name;

      this.steps[this.currentStep + 1].props = {
        team: this.selectedTeam,
        event: this.selectedEvent,
        judge: judge,
      };
      this.currentStep++;
    },

    selectEventKind(eventKind) {
      this.selectedEventKind = eventKind;
      this.steps[this.currentStep][
        "description"
      ] = this.selectedEventKind.title;
      this.steps[this.currentStep + 1].props = {
        kind: this.selectedEventKind["kind"] || "",
      };
      this.currentStep++;
    },

    selectEvent(event) {
      this.selectedEvent = event;
      this.steps[this.currentStep]["description"] = this.selectedEvent.name;
      this.steps[this.currentStep + 1].props = {
        team: this.selectedTeam,
        event: this.selectedEvent,
      };
      this.currentStep++;
    },

    confirmRegistration(info) {
      const teamId = _.get(info, "teamId", "");
      const eventId = _.get(info, "eventId", "");

      const enrollmentArgs = this.isJudge
        ? [eventId, teamId, "judge", info.judge || {}]
        : [eventId, teamId];

      Event.createEnrollment.apply({}, enrollmentArgs).then(
        (res) => {
          const enrollmentId = _.get(res.data, "_id");
          const cache = res.data;

          // Fix not populate of event in enrollment
          cache.event = this.selectedEvent;

          this.$router.push({
            name: this.isJudge ? "home" : "submit",
            params: { cache: res.data, modelId: enrollmentId },
          });
        },
        (err) => {
          this.loading = false;

          const status = ParseHTTPError(err);
          let error = status.error;

          if (!status.type) {
            error =
              "Houve um erro na comunicação com o servidor, tente novamente";
          }

          this.$notify.error({
            title: "Erro",
            message: error,
          });
        }
      );
    },

    emptyStep(stepNumber) {
      switch (stepNumber) {
        case 0:
          // Empty team
          this.selectedTeam = {};
          this.steps[0]["description"] = null;
          break;

        case 1:
          // Empty Event Kind
          this.selectedEventKind = {};
          this.steps[1]["description"] = null;
          break;

        case 2:
          // Empty Event
          this.selectedEvent = {};
          this.steps[2]["description"] = null;
          break;
      }
    },

    updateMe() {
      this.$router.push({
        name: "signup",
        params: { community: this.community },
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/Registration/Registration.js